import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { MessageTypeConstants } from "../../../services/bot/Message";
import { getAuthData, getFromLocalStorage, saveInLocalStorage } from "../../../services/storage/LocalStorage";
import { handlePromptOnClose, processAndRemoveTab, resetForm2Fields, setTabState } from "../../../state/actions/tabStack";
import { processSendMessage } from "../../../services/bot/conversation/SendMessage";
import { handleMessageTypeForm2 } from "../../../state/actionsHelpers/tabStackActionsHelpers/message-type-form2";
import { handlePromptOnCloseForModal, showTabCloseModal } from "../../../state/actions/modal";
import { setBotWaitLoaderWithShimmer } from "../../../state/actions/loader";
import { useEffect } from "react";
import { LFStorageKeys } from "../../../services/storage/LFStorage";
import CommonModalPopUp from "../../ui/Modals/ModalPopupCommon";
import FMFormComponent from "./FormComponent";


const FMForm = ({ message, parentTabIdKey }) => {

	const rawContent = message?.message;
	const isArray = Array.isArray(rawContent);
	const content = isArray || (typeof rawContent === 'object' && rawContent !== null)
		? rawContent
		: {};

	const fields = isArray ? content : content?.fields ?? [];

	const collectionData = !isArray &&
		typeof content?.collectionData === 'object' &&
		content?.collectionData !== null &&
		Object.keys(content.collectionData).length > 0
		? content.collectionData
		: null;

	const cardsSetData = !isArray &&
		content?.cardsSetData &&
		typeof content.cardsSetData === 'object' &&
		content.cardsSetData !== null &&
		Object.keys(content.cardsSetData).length > 0
		? content.cardsSetData
		: null;


	const dashboardsData = !isArray ? content?.dashboardsData : null;
	const options = message?.options ?? {};
	const parentTabId = parentTabIdKey ? parentTabIdKey : options.tabId;
	const conversation = message?.conversation ?? null;;
	const genericError = message?.genericError ?? null;;
	const parentMessageType = message?.parentMessageType ?? null;

	const promptOnCloseForModal = useSelector((state) => state.modal?.promptOnCloseForModal) || null;

	const parentDocIdOfPreviousMessage = getFromLocalStorage(LFStorageKeys.PREVIOUS_DOC_ID);
	const initialParentDocId = options.parentDocId
		? options.parentDocId
		: options?.docId || null;

	const [parentDocId, setParentDocId] = useState(initialParentDocId);

	const dispatch = useDispatch();
	const { user: { userTimezone = null }, } = getAuthData() || {};
	const defaultUserTimezone = "Etc/UTC";

	//=> set parentDocId from previous message if we are getting the current message as modal
	//=> to send to backend the as initial tab's docId
	useEffect(() => {
		if (!options.modal && parentDocId) {
			saveInLocalStorage(LFStorageKeys.PREVIOUS_DOC_ID, parentDocId);
		} else if (options.modal && parentDocIdOfPreviousMessage) {
			setParentDocId(parentDocIdOfPreviousMessage)
		}
	}, [options, parentDocId, parentDocIdOfPreviousMessage]);


	const handleAction = (action, currentField = null, currentFieldValue = null, isCurrFldObj = false) => {
		const tabId = parentTabId ? parentTabId : options.tabId;

		const responseChat = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE,
			message: {
				formId: options.formId,
				tabId,
				parentDocId,
				action,
				currentField,
				content: isCurrFldObj ? currentFieldValue : { currentFieldValue },
				docId: options?.docId,
				tz: userTimezone || defaultUserTimezone,
			},
			...(action !== "click" && { options }),
		};

		if (action === "click") {
			if (message.options.modal && message.hidden) {
				dispatch(processAndRemoveTab(conversation, message));
			}
			else {
				dispatch(handlePromptOnClose(conversation));
			}
		}
		if (action !== "move") {
			dispatch(setBotWaitLoaderWithShimmer(true));
		}
		dispatch(setTabState(false))
		processSendMessage(responseChat);
	};

	const onCardAction = (cardData, itemParent, itemIndex) => {
		const cardSetId = Array.isArray(itemParent) && itemParent[0]?.options?.cardSetId
			? itemParent[0].options.cardSetId : itemParent?.cardSetId

		const tabId = parentTabId ? parentTabId : options.tabId;

		const parametersData = {
			messageType: "card_response",
			message: {
				controlId: cardData.controlId,
				cardId: cardData.id,
				cardSetId: cardSetId,
				tabId,
			}
		};

		dispatch(setBotWaitLoaderWithShimmer(true));
		dispatch(setTabState(false))
		processSendMessage(parametersData);
	};


	const handleConfirm = () => {
		const messageObj = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE,
			message: {
				formId: options?.formId,
				tabId: parentTabId ? parentTabId : options.tabId,
				parentDocId,
				docId: options?.docId,
				action: "confirm",
				fields: fields || message,
				collectionData,
			},
			options: options ?? null
		}
		processSendMessage(messageObj);
		dispatch(setTabState(false))
		if (options.modal) {
			dispatch(handlePromptOnCloseForModal(true));
		};

		dispatch(handlePromptOnClose(conversation));
		dispatch(setBotWaitLoaderWithShimmer(true));
		if (options.allowClose && options.minimizeOnConfirm) {
			dispatch(processAndRemoveTab(conversation, message));
		}
	};


	const handleCancel = () => {
		if (promptOnCloseForModal) {
			dispatch(showTabCloseModal(message));
		}
		else if (options?.promptOnClose) {
			if (options.modal) {
				const messageObj = {
					messageType: MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE,
					message: {
						formId: options.formId,
						tabId: parentTabId ? parentTabId : options.tabId,
						parentDocId,
						docId: options?.docId,
						action: "cancel",
					},
					options: options || {}
				}
				dispatch(setTabState(false))
				processSendMessage(messageObj);
				dispatch(processAndRemoveTab(conversation, message));
			}
			else {
				dispatch(showTabCloseModal(message));
			}
		}
		else if (options.modal) {
			const messageObj = {
				messageType: MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE,
				message: {
					formId: options.formId,
					tabId: parentTabId ? parentTabId : options.tabId,
					parentDocId,
					docId: options?.docId,
					action: "cancel",
				},
				options: options || {}
			}
			dispatch(setTabState(false))
			processSendMessage(messageObj);
			dispatch(processAndRemoveTab(conversation, message));
		}
		else {
			dispatch(resetForm2Fields(conversation, message));
			dispatch(processAndRemoveTab(conversation, message));
		}
	};


	const updateRedux = (field, isSearched) => {
		const formMessage = {
			message: {
				update: [field],
			},
			options: {
				action: "change",
				controlId: options.controlId,
				formId: options.formId,
				tabId: parentTabId ? parentTabId : options.tabId,
				parent: options.parent,
				parentDocId,
				docId: options?.docId,
				isSearchedFrontedKey: isSearched,
				...options
			},
		};
		dispatch(handleMessageTypeForm2(conversation, formMessage));
	};

	const formComponent = (
		<FMFormComponent
			className="fm-form"
			options={options}
			message={message}
			conversation={conversation}
			fields={fields || message}
			handleAction={handleAction}
			updateRedux={updateRedux}
			genericError={genericError}
			parentTabId={parentTabId}
			parentDocId={parentDocId}
			handleConfirm={handleConfirm}
			onCardAction={(e, itemparent, index) => onCardAction(e, itemparent, index)}
			handleCancel={handleCancel}
			collectionData={collectionData}
			cardsSetData={cardsSetData}
			dashboardsData={dashboardsData}
			parentMessageType={parentMessageType}
		/>)

	const onClose = () => {

		if (promptOnCloseForModal) {
			dispatch(showTabCloseModal(message));
			console.log("Prompting user for confirmation before closing the modal.");
			
			return;
		}

		const sendMessageObj = {
			messageType: MessageTypeConstants.MESSAGE_TYPE_FORM_RESPONSE,
			message: {
				controlId: options.controlId,
				tabId: options.tabId,
				docId: options.docId,
				action: "close",
			},
		};

		dispatch(setTabState(false));
		processSendMessage(sendMessageObj);
		dispatch(processAndRemoveTab(conversation, message));
	};

	return (
		<>
			{/* Form opens up inside a modal or tab, as per the param {modal : true} received from bot  */}
			{options.modal
				? (<CommonModalPopUp onClose={() => onClose()}>
					{formComponent}
				</CommonModalPopUp>)
				: (
					<>
						{formComponent}
					</>
				)
			}
		</>
	);
};

export default FMForm;
